import {useMutation} from "@tanstack/react-query";

import {addClientNoteMutationOptions} from "./add-client-note.mutation-options";

export function useAddClientNote(clientId: string) {
  return useMutation(addClientNoteMutationOptions(clientId));
}
